var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 2.8H18.9V0H17.3V2.8H7.7V0H6.1V2.8H1.7C1.38185 2.80037 1.07684 2.92692 0.851881 3.15188C0.626918 3.37684 0.500371 3.68185 0.5 4V20.8C0.500371 21.1181 0.626918 21.4232 0.851881 21.6481C1.07684 21.8731 1.38185 21.9996 1.7 22H23.3C23.6181 21.9996 23.9232 21.8731 24.1481 21.6481C24.3731 21.4232 24.4996 21.1181 24.5 20.8V4C24.4996 3.68185 24.3731 3.37684 24.1481 3.15188C23.9232 2.92692 23.6181 2.80037 23.3 2.8ZM22.9 20.4H2.1V4.4H6.1V6.4H7.7V4.4H17.3V6.4H18.9V4.4H22.9V20.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8998 9.19995H5.2998V10.8H6.8998V9.19995Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3002 9.19995H9.7002V10.8H11.3002V9.19995Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3002 9.19995H13.7002V10.8H15.3002V9.19995Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 9.19995H18.0996V10.8H19.6996V9.19995Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8998 12.7998H5.2998V14.3998H6.8998V12.7998Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3002 12.7998H9.7002V14.3998H11.3002V12.7998Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3002 12.7998H13.7002V14.3998H15.3002V12.7998Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 12.7998H18.0996V14.3998H19.6996V12.7998Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8998 16.4004H5.2998V18.0004H6.8998V16.4004Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3002 16.4004H9.7002V18.0004H11.3002V16.4004Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3002 16.4004H13.7002V18.0004H15.3002V16.4004Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 16.4004H18.0996V18.0004H19.6996V16.4004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.e9ff0c2c43f2ca5ad994e7b13201317f.svg";
export { ForwardRef as ReactComponent };